import { jsx as _jsx } from "react/jsx-runtime";
import { KinderConnectCaptureSettingsChildrenListError } from './kinder-connect-capture-settings-children-list-error';
import { KinderConnectCaptureSettingsChildrenListLoading } from './kinder-connect-capture-settings-children-list-loading';
import { KinderConnectCaptureSettingsChildrenListEmptyState } from './kinder-connect-capture-settings-children-list-empty-state';
import { KinderConnectCaptureSettingsChildrenListRows } from './kinder-connect-capture-settings-children-list-rows';
/**
 * Picks which of the list's four states to render: error, loading, empty, or the matched rows.
 * A plain component (rather than an inline conditional) so the branching is ordinary, top-level
 * control flow instead of a closure re-created on every parent render.
 */
export const KinderConnectCaptureSettingsChildrenListBody = ({ error, loading, matchedChildren, toggleState, isDisabled, onToggle, }) => {
    if (error) {
        return _jsx(KinderConnectCaptureSettingsChildrenListError, {});
    }
    if (loading) {
        return _jsx(KinderConnectCaptureSettingsChildrenListLoading, {});
    }
    if (matchedChildren.length === 0) {
        return _jsx(KinderConnectCaptureSettingsChildrenListEmptyState, {});
    }
    return (_jsx(KinderConnectCaptureSettingsChildrenListRows, { matchedChildren: matchedChildren, toggleState: toggleState, isDisabled: isDisabled, onToggle: onToggle }));
};
